export default __webpack_public_path__ + "static/media/19.72c32f6a.gif";